var React = require('react');

function KbdArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 0L3 4.913 7.144 4.913 7.144 16 8.856 16 8.856 4.913 13 4.913z"}));
}

KbdArrowUp.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdArrowUp;

KbdArrowUp.default = KbdArrowUp;
